import { useTranslation } from 'react-i18next'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { HouseConsignmentFormValues } from 'features/declaration/house-consignment/models/schema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import FormCollapsibleColumn from '../../../../components/p5/FormCollapsibleColumn'
import Input from '../../../../components/p5/Input'
import FormField from '../../../../components/p5/FormField'
import FormSelect from '../../../../components/p5/FormSelect'
import useDeclarationFieldRequirements from '../../form/components/useDeclarationFieldRequirements'

const scope = 'placeOfAcceptance'

function PlaceOfAcceptance() {
  const { control } = useFormContext<HouseConsignmentFormValues>()

  const isDifferentPlaceOfAcceptance = useWatch({
    control,
    name: 'differentPlaceOfAcceptance',
  })

  const { t } = useTranslation()
  const [, countriesOptions] = useCodelist('COUNTRIES')

  const fieldRequirements = useDeclarationFieldRequirements<HouseConsignmentFormValues>('houseConsignment', [
    'differentPlaceOfAcceptance',
    'placeOfAcceptance',
    'placeOfAcceptance.country',
    'placeOfAcceptance.nationality',
    'placeOfAcceptance.location',
  ])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-acceptance-place"
        headingLabel={t('declaration.p5.placeOfAcceptance')}
        fieldRule={fieldRequirements[scope]}
      >
        <div className="row mb-2">
          <div className="d-flex mb-2 col-8">
            <Input
              field="differentPlaceOfAcceptance"
              type="checkbox"
              labelKey="Different place of acceptance from consignment"
              fieldRule={fieldRequirements.differentPlaceOfAcceptance}
            />
          </div>
        </div>
        {isDifferentPlaceOfAcceptance && (
          <>
            <FormField
              labelKey="declaration.p5.nationality"
              fieldRule={fieldRequirements[`${scope}.country`]}
            >
              <FormSelect
                field={`${scope}.country`}
                labelKey="declaration.p5.nationality"
                options={countriesOptions}
                type="sync"
                fieldRule={fieldRequirements[`${scope}.country`]}
              />
            </FormField>
            <FormField
              labelKey="declaration.p5.placeOfAcceptanceLocation"
              fieldRule={fieldRequirements[`${scope}.location`]}
            >
              <Input
                field={`${scope}.location`}
                labelKey="declaration.p5.placeOfAcceptanceLocation"
                type="text"
                maxLength={35}
                placeholder={t('declaration.p5.placeOfAcceptanceLocation')}
                fieldRule={fieldRequirements[`${scope}.location`]}
              />
            </FormField>
          </>
        )}
      </FormCollapsibleColumn>
    </section>
  )
}

export default PlaceOfAcceptance
